import { useTheme, useMediaQuery } from '@mui/material';

/**
 * Max CSS width for the native-like mobile shell (bottom nav, no permanent drawer).
 * Uses 1024px (not MUI `sm` 600px) so phone landscape and small tablets do not
 * fall back to the desktop sidebar + missing bottom nav (004 UX).
 */
export const MOBILE_SHELL_MAX_WIDTH_PX = 1024;

export function useMobileShell(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(MOBILE_SHELL_MAX_WIDTH_PX), {
    noSsr: true,
    defaultMatches: true,
  });
}
